import styled from 'styled-components';

const OpenRolesStyle = styled.section`
	.RolesItemCont {
		--rolesPad: var(--sp3x);
		--RolesItemPopUpContPadTop: var(--sp3x);
		--RolesItemPopUpContPadBottom: var(--sp5x);
		--plusIconSize: 28px;
		--liDotsSize: 6px;
		--BtnArrow: 100px;

		margin-top: var(--titleToContent);

		.RolesItemWrap {
			opacity: 0;
			border-top: 2px solid var(--color1);

			&:last-child {
				border-bottom: 2px solid var(--color1);
			}

			.RolesItem {
				padding: var(--rolesPad) 0;
				position: relative;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.Profession {
					flex: 0 0 70%;
					max-width: 70%;
					margin-bottom: var(--sp2x);
				}

				.WorkingHours {
					flex: 0 0 50%;
					max-width: 50%;
				}

				.Location {
					flex: 0 0 50%;
					max-width: 50%;
				}

				.PlusCont {
					flex: 0 0 30%;
					max-width: 30%;

					.Plus {
						display: inline-block;
						width: var(--plusIconSize);
						height: var(--plusIconSize);

						svg {
							fill: none;
							stroke-width: 4px;
							stroke: var(--color1);
						}
					}
				}

				p,
				div {
					&:nth-child(2n) {
						text-align: right;
					}
				}
			}
		}

		.RolesItemPopUpCont {
			padding: var(--RolesItemPopUpContPadTop) 0 var(--RolesItemPopUpContPadBottom);

			.RolesItemPopUp {
				margin-bottom: var(--titleToContent);
			}

			.RolesPopUpTile {
				margin-bottom: var(--sp4x);
			}

			.RolesItemPopUpListCont {
				.RolesPopUpList {
					position: relative;
					padding-left: var(--sp2x);
					margin-bottom: var(--sp2x);

					&:after {
						content: '';
						border-radius: 100px;
						overflow: hidden;
						position: absolute;
						top: calc((var(--pM) / 2) + 2px);
						left: 0;
						width: var(--liDotsSize);
						height: var(--liDotsSize);
						background-color: currentColor;
					}
				}
			}

			.ApplyInfoLink {
				.BtnArrow {
					width: var(--BtnArrow);
					svg {
						overflow: visible;
						fill: var(--color1);
					}
				}

				.scrollLink {
					div {
						background-color: var(--color1);
						p {
							color: var(--color2);
						}
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--rolesPad: var(--sp4x);
			--RolesItemPopUpContPadTop: var(--sp4x);
			--RolesItemPopUpContPadBottom: var(--sp8x);
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.RolesItemWrap {
				.RolesItem {
					.Profession {
						order: 1;
						flex: 0 0 40%;
						max-width: 40%;
						margin-bottom: 0;
					}

					.WorkingHours {
						order: 2;
						flex: 0 0 20%;
						max-width: 20%;
						text-align: center;
						padding: 0 var(--sp2x);
					}

					.Location {
						order: 3;
						flex: 0 0 20%;
						max-width: 20%;
						padding: 0 var(--sp2x);
					}

					.PlusCont {
						order: 4;
						flex: 0 0 var(--plusIconSize);
						max-width: var(--plusIconSize);
					}

					p:nth-child(2n) {
						text-align: center;
					}
				}

				.RolesItemPopUpCont {
					border-top: 2px solid var(--color1);
					display: flex;
					flex-direction: column;
					align-items: flex-end;

					.RolesItemPopUp {
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;

						.RolesPopUpTile {
							flex: var(--sectionTitleMaxWidth);
							max-width: var(--sectionTitleMaxWidth);
						}

						.RolesItemPopUpListCont {
							flex: var(--sectionInfoMaxWidth);
							max-width: var(--sectionInfoMaxWidth);
						}
					}

					.ApplyInfoLink {
						width: 100%;
						max-width: var(--sectionInfoMaxWidth);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--rolesPad: var(--sp5x);
			--RolesItemPopUpContPadTop: var(--sp5x);
			--RolesItemPopUpContPadBottom: var(--sp8x);
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--plusIconSize: 30px;
			--BtnArrow: 120px;

			padding-left: var(--contPadLeft);
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--rolesPad: var(--sp6x);
			--RolesItemPopUpContPadTop: var(--sp6x);
			--RolesItemPopUpContPadBottom: var(--sp8x);
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--plusIconSize: 36px;
			--BtnArrow: 130px;
			--rolesPad: var(--sp6x);
			--RolesItemPopUpContPadTop: var(--sp6x);
			--RolesItemPopUpContPadBottom: var(--sp8x);
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--plusIconSize: 48px;
			--liDotsSize: 8px;
			--BtnArrow: 150px;
			--rolesPad: var(--sp7x);
			--RolesItemPopUpContPadTop: var(--sp7x);
			--RolesItemPopUpContPadBottom: var(--sp10x);
		}
	}
`;

export default OpenRolesStyle;
